function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useStore, useStoreActions } from "../../store/store-context";
import React from 'react';
import { ContactModalType, ManageContactModal } from "./index";
import { handleRequest, sendErrReport } from "../../infra/utils";
import { useGlobalContext } from 'seagull';
export function ManageContactModalForClient(props) {
  var _userInfo$worksAt;

  const {
    onClose,
    origin
  } = props;
  const {
    api,
    setUserInfo
  } = useStoreActions();
  const userInfo = useStore(state => state.userInfo);
  const globalContext = useGlobalContext();
  const contact = {
    firstName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName) || '',
    lastName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName) || '',
    companyName: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$worksAt = userInfo.worksAt) === null || _userInfo$worksAt === void 0 ? void 0 : _userInfo$worksAt.name) || '',
    email: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) || '',
    phone: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone) || null
  };

  const onSaveContact = async contact => {
    if (!(userInfo !== null && userInfo !== void 0 && userInfo.worksAt)) return;
    const shouldUpdateContactDetails = userInfo.firstName !== contact.firstName || userInfo.lastName !== contact.lastName || userInfo.phone !== contact.phone;
    const didUpdateCompanyName = userInfo.worksAt.name !== contact.companyName;
    let updateUserDetailsSuccess, updateCompanySuccess;

    if (shouldUpdateContactDetails) {
      const [editUserDetailsRes, err, hasError] = await handleRequest(api.auth.editUserDetails({
        phone: contact.phone,
        name: {
          first: contact.firstName,
          last: contact.lastName
        },
        clearPhoneNumber: false
      }));

      if (hasError) {
        sendErrReport(err);
        globalContext.showErrorToast('Failed to save contact details', 'save-contact-details-failure-toast');
      } else {
        setUserInfo(_objectSpread(_objectSpread({}, userInfo), editUserDetailsRes));
        updateUserDetailsSuccess = true;
      }
    }

    const updateUserDetailsDone = !shouldUpdateContactDetails || updateUserDetailsSuccess;
    const shouldUpdateCompanyName = didUpdateCompanyName && updateUserDetailsDone;

    if (shouldUpdateCompanyName) {
      var _userInfo$worksAt2;

      const [, err, hasError] = await handleRequest(api.vendor.updateBusinessDetails(userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$worksAt2 = userInfo.worksAt) === null || _userInfo$worksAt2 === void 0 ? void 0 : _userInfo$worksAt2.id, {
        name: contact.companyName
      }));

      if (hasError) {
        sendErrReport(err);
        globalContext.showErrorToast('Failed to save company name', 'save-company-name-failure-toast');
      } else {
        const worksAt = _objectSpread(_objectSpread({}, userInfo === null || userInfo === void 0 ? void 0 : userInfo.worksAt), {}, {
          name: contact.companyName
        });

        setUserInfo(_objectSpread(_objectSpread({}, userInfo), {}, {
          worksAt
        }));
        updateCompanySuccess = true;
      }
    }

    const updateCompanyNameDone = !shouldUpdateCompanyName || updateCompanySuccess;
    return updateUserDetailsDone && updateCompanyNameDone ? contact : undefined;
  };

  return /*#__PURE__*/React.createElement(ManageContactModal, {
    onClose: onClose,
    contact: contact,
    modalType: ContactModalType.Edit,
    onSaveContact: onSaveContact,
    emailEditState: {
      isEmailReadonly: true
    },
    onCancelClick: async () => true,
    origin: origin
  });
}